<template>
    <div>
        <transition>
            <div
                    v-if="shown"
                    class="alert alert-warning text-center" role="alert">
                <button
                        v-if="!confirmationShown"
                        v-on:click="showConfirmation"
                        type="button"
                        class="close">
                    ×
                </button>
                {{ 'Remember to check your availabilities for the next days.' | trans }}
                <div>
                    <button
                            v-on:click="showAvailabilities"
                            class="btn btn-default">
                        <i class="icon fa fa-calendar"></i>
                        {{ 'Check my availabilities' | trans }}
                    </button>
                </div>
                <div
                        v-if="confirmationShown"
                        class="confirmation">
                    <input
                            v-on:click="confirm"
                            type="checkbox">
                    {{ 'I confirm that I have checked my availabilities.' | trans }}
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import localForage from 'localforage';
    import moment from 'moment';

    const storageKey = 'AvailabilitiesReminderMessageComponent';

    export default {
        data() {
            return {
                shown: false,
                confirmationShown: false,
                interval: null,
                lastDismissAt: null
            }
        },
        methods: {
            showAvailabilities() {
                this.shown = false;
                this.dismiss();
                this.$router.push('availabilities');
            },
            showConfirmation() {
                this.confirmationShown = true;
            },
            confirm() {
                setTimeout(
                    () => {
                        this.shown = false;
                        this.confirmationShown = false;
                    },
                    300
                );
                this.dismiss();
            },
            async dismiss() {
                this.lastDismissAt = new Date();
                localForage.setItem(storageKey, {lastDismissAt: this.lastDismissAt});
            },
            showPopupIfNeeded() {
                if (
                    !this.shown
                    && (
                        // show the popup only once per day,
                        //   - after 0pm if the last dismiss was made the day before, before 14pm
                        //   - after 14pm if the last dismiss was made the day before, after 14pm
                        (moment().hour() < 14 && moment(this.lastDismissAt).isBefore(moment().startOf('day').subtract(1, 'day').hour(14)))
                        || (moment().hour() >= 14 && moment(this.lastDismissAt).isBefore(moment().startOf('day')))

                        // testing purpose
                        // (moment().second() >= 14 && moment(this.lastDismissAt).isBefore(moment().startOf('minute')))
                        // || (moment().second() < 14 && moment(this.lastDismissAt).isBefore(moment().startOf('minute').subtract(1, 'minute').second(14)))
                    )
                ) {
                    this.shown = true;
                }
            }
        },
        async created() {
            const storedItem = await localForage.getItem(storageKey);
            if (storedItem !== null && storedItem.lastDismissAt instanceof Date) {
                this.lastDismissAt = storedItem.lastDismissAt;
            }
            else {
                this.dismiss(); // 'virtual' dismiss, if local storage is fresh
            }
            this.showPopupIfNeeded();
            this.interval = setInterval(
                this.showPopupIfNeeded,
                1000*60
                // testing purpose
                //1000
            )
        },
        destroy() {
            if (this.interval !== null) {
                clearInterval(this.interval);
            }
        }
    }
</script>

<style scoped>
    .close {
        margin-left: 10px;
    }
    input[type=checkbox] {
        -ms-transform: scale(2); /* IE */
        -moz-transform: scale(2); /* FF */
        -webkit-transform: scale(2); /* Safari and Chrome */
        -o-transform: scale(2); /* Opera */
        margin-right: 10px;
    }
    .confirmation {
        margin-top: 10px;
    }
    .v-leave-active {
        transition: all 300ms;
    }
    .v-leave {
        opacity: 1;
        max-height: 200px;
    }
    .v-leave-to {
        opacity: 0;
        max-height: 0;
    }
</style>
